import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-workshop',
  templateUrl: './workshop.component.html',
  styleUrls: ['./workshop.component.css']
})
export class WorkshopComponent implements OnInit {

  banner: any = {
    pagetitle: "Guidence Session",
    bg_image: "assets/images/banner/bnr3.jpg",
    title: "Guidance Session",
  }

  constructor() { }

  ngOnInit(): void {
  }

  open(){
    window.open('https://forms.gle/orrAK61E62tCaXcN7', '_blank')
  }

}
